import createWhoamiContext from '@lib/contexts/createWhoamiContext';
import useWhoamiQueryHook from 'utils/fetch/hooks/useWhoamiQueryHook';

export type WhoamiContextValue = ReturnType<typeof useWhoamiQueryHook>;

const { WhoamiContext, useWhoamiContext } =
  createWhoamiContext<WhoamiContextValue>();

export { useWhoamiContext };
export default WhoamiContext;
